/**
 * Screen System - Main exports
 */

// Re-export everything from the screen directory
export * from "./screen/index.js";
